export default '5.15.0';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/version/version.js
// module id = 3492
// module chunks = 0